import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
// import Link from 'next/link';
import dynamic from "next/dynamic";

import { api } from "@utils/api";
import Loading from "@components/Loading";
import { useApp } from "@context/AppProvider";

import CartParcelItems from "./CartParcelItems";
import ShippingOptions from "./ShippingOptions";

const PromoModal = dynamic(() => import("@models/promo.modal"));

function CartAndShipping(props) {
  const {
    styles,
    items,
    address,
    loading,
    dispatch,
    session,
    selectedShippings,
    selectedAddress,
    cartData,
    user,
    isGuest = false,
  } = props;
  const [promo, setPromo] = useState(null);
  const [promotions, setPromotions] = useState({});
  const rp = useMemo(() => {
    let RP = {};
    for (let i = 0; i < items.length; i++) {
      const p = items[i];
      if (RP[p.retailer_id]) {
        RP[[p.retailer_id]].products.push(p);
      } else {
        RP[p.retailer_id] = {
          ...p.product_data.retailer,
          id: p.retailer_id,
          products: [{ ...p }],
        };
      }
    }
    return RP;
  }, [items]);

  const [shipping, setShipping] = useState({
    loading: false,
    items: [],
  });
  const [selectedShip, setSelectedShip] = useState(selectedShippings);

  const loadData = useCallback(async () => {
    if (selectedAddress._id || (isGuest && selectedAddress.address)) {
      setShipping({
        loading: true,
        items: [],
      });
      const res = await api(
        {
          url: "/cart/shiping-options",
          method: "POST",
          data: {
            selectedAddress,
            isGuest,
          },
        },
        session
      );

      if (!res.status) {
        dispatch({
          type: "SET_ERROR",
          data: {
            error: {
              msg: res.message,
            },
            address: {},
          },
        });
        setShipping({
          loading: false,
          items: [],
        });

        return;
      }
      const amtKey =
        selectedAddress.country === "New Zealand"
          ? "totalAmountExTax"
          : "total_amount";

      const defaultSelects = [];
      for (let i = 0; i < res.data.length; i++) {
        const item = res.data[i];
        if (item.options.length === 1) {
          const op = item.options[0];
          const shipping = {
            // eslint-disable-next-line camelcase
            retailer_id: item.retailer_id,
            option: op.option,
            value: op.value,
            freeShipping: op.free_shipping,
            actualValue: op.actualValue,
          };
          const amount = items
            .filter((item) => item.retailer_id === shipping.retailer_id)
            .map((i) => i[amtKey])
            .reduce((a, b) => a + b, 0);

          if (
            shipping.freeShipping !== null &&
            shipping.freeShipping > 0 &&
            amount >= shipping.freeShipping
          ) {
            shipping.value = 0;
            shipping.actualValue = 0;
          }

          defaultSelects.push(shipping);
        }
      }

      if (defaultSelects.length) {
        const result = await api(
          {
            url: "/cart/update-shipping",
            method: "POST",
            data: {
              shippings: defaultSelects,
              isGuest,
            },
          },
          session
        );
        const cData = cartData(result, user);

        dispatch({
          type: "SET_DATA",
          data: {
            shipping: cData.shipping,
            promo: cData.promo,
            total: cData.total,
          },
        });
        let shipping = {};
        for (let i = 0; i < cData.shipping.length; i++) {
          const ship = cData.shipping[i];
          shipping[ship.retailer_id] = ship.option;
        }
        setSelectedShip(shipping);
        setShipping({
          loading: false,
          items: res.data,
        });
      } else {
        setShipping({
          loading: false,
          items: res.data,
        });
      }

      dispatch({ type: "SET_SHIPPING" });
    }
  }, [session, selectedAddress, cartData, isGuest, user, items, dispatch]);

  const {
    idb: { session: sess },
  } = useApp();

  const loadVouchers = useCallback(
    async (data) => {
      if (data?.products && data?.id) {
        const req = {
          productIds: data?.products?.map((i) => i.product_id),
          retailerId: data?.id,
        };
        const res = await api(
          {
            url: "/cart/product-voucher",
            method: "POST",
            data: req,
          },
          sess
        );
        setPromotions((pre) => ({
          ...pre,
          [data?.id + data?.products?.map((i) => i.product_id).join("")]: res,
        }));
      }
    },
    [sess]
  );

  useEffect(() => {
    Object.keys(rp).map((i) => {
      loadVouchers(rp[i]);
    });
  }, [rp]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      <div className={styles.yourBagBlock}>
        {loading ? (
          <Loading.LineLoader />
        ) : (
          Object.keys(rp).map((i, index) => {
            const data = rp[i];
            return (
              <React.Fragment
                key={`cartshipping-${index}-${new Date().toISOString()}`}
              >
                <div className="row">
                  <RowItem
                    styles={styles}
                    dispatch={dispatch}
                    address={address}
                    index={index}
                    data={data}
                    setPromo={setPromo}
                    user={user}
                    session={session}
                    cartData={cartData}
                    selectedAddress={selectedAddress}
                    country={selectedAddress.country}
                    item={shipping.items[index]}
                    count={index + 1}
                    retailerId={data.id}
                    products={data.products}
                    selectedShippings={selectedShip}
                    isGuest={isGuest}
                    fecthShippingLoader={shipping.loading}
                    promotions={promotions}
                  />
                </div>
                <hr className={`row`} />
              </React.Fragment>
            );
          })
        )}
      </div>
      {promo && (
        <PromoModal
          promotions={[]}
          close={() => setPromo(null)}
          cart={promo}
          isGuest={isGuest}
        ></PromoModal>
      )}
    </>
  );
}

const RowItem = memo(function RowItem(props) {
  const {
    styles,
    dispatch,
    address,
    index,
    data,
    setPromo,
    user,
    session,
    cartData,
    selectedAddress,
    selectedShippings,
    isGuest,
    fecthShippingLoader,
    item,
    promotions,
  } = props;

  const promo = useMemo(
    () =>
      promotions?.[
        data?.id + data?.products?.map((i) => i.product_id).join("")
      ],
    [data?.products, data?.id, promotions]
  );

  const pItem = useMemo(
    () => (
      <CartParcelItems
        styles={styles}
        dispatch={dispatch}
        country={address?.country || ""}
        index={index}
        data={data}
        setPromo={setPromo}
        promo={promo}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [address?.country, data, promo]
  );

  const shippingOp = useMemo(
    () => (
      <ShippingOptions
        user={user}
        styles={styles}
        session={session}
        dispatch={dispatch}
        cartData={cartData}
        index={index}
        selectedAddress={selectedAddress}
        country={selectedAddress.country}
        item={item}
        count={index + 1}
        retailerId={data.id}
        products={data.products}
        selectedShippings={selectedShippings}
        isGuest={isGuest}
        fecthShippingLoader={fecthShippingLoader}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedAddress, selectedShippings, fecthShippingLoader, data.products]
  );

  return (
    <React.Fragment>
      {pItem}
      {shippingOp}
    </React.Fragment>
  );
});

export default memo(CartAndShipping);
